import { render, staticRenderFns } from "./AppUserProfile.vue?vue&type=template&id=dced3c32&scoped=true"
import script from "./AppUserProfile.vue?vue&type=script&lang=js"
export * from "./AppUserProfile.vue?vue&type=script&lang=js"
import style0 from "./AppUserProfile.vue?vue&type=style&index=0&id=dced3c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dced3c32",
  null
  
)

export default component.exports